import { useEffect, useMemo } from 'react';
import { useFetch } from 'app/queryProvider';
import { OnboardingRoutes } from '../api';
import type { TTourListResponse, TTourRegistry } from '../types';
import { toTourRegistry, traceTour } from '../utils';

export const useTourCatalogue = (enabled: boolean): TTourRegistry => {
  const { data, error } = useFetch<TTourListResponse>({
    queryKey: [['onboarding', 'tours']],
    url: OnboardingRoutes.tours.list(),
    resource: { name: 'onboarding' },
    options: {
      enabled,
      staleTime: Infinity,
    },
  });

  useEffect(() => {
    if (error) {
      traceTour('catalogue request failed:', error);
    }
  }, [error]);

  return useMemo(() => {
    const registry = toTourRegistry(data?.results);
    const ids = Object.keys(registry);

    traceTour('catalogue:', ids.length ? ids : 'empty, no mobile tours seeded');

    return registry;
  }, [data]);
};
